import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-diferentials',
  templateUrl: './diferentials.component.html',
  styleUrls: ['./diferentials.component.scss']
})
export class DiferentialsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
